var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJustPointMore = function SvgJustPointMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 13.9996C26 15.615 24.6898 16.9252 23.0744 16.9252C21.459 16.9252 20.1494 15.615 20.1494 13.9996C20.1496 12.3844 21.4592 11.0742 23.0744 11.0742C24.6896 11.0742 26 12.3844 26 13.9996ZM7.85039 13.9996C7.85039 15.615 6.54023 16.9252 4.9248 16.9252C3.30938 16.9252 2 15.6148 2 13.9996C2 12.3844 3.30957 11.0742 4.925 11.0742C6.54043 11.0742 7.85039 12.3844 7.85039 13.9996ZM16.9252 13.9996C16.9252 15.615 15.615 16.9252 13.9996 16.9252C12.3844 16.9252 11.0742 15.615 11.0742 13.9996C11.0742 12.3844 12.3844 11.0742 13.9996 11.0742C15.615 11.0742 16.9252 12.3844 16.9252 13.9996Z",
    fill: "currentColor"
  })));
};
export default SvgJustPointMore;